import { Model } from '../../Models/model';
import { ScreenModel } from '../../Models/screen-model';

export class ScreenStore {
  private static models: ScreenModel[];
  private static idCounter = 0;
  public static initMocks() {
    ScreenStore.models = [];
    ScreenStore.models.push({ id: "ufueffyeyfe", screenId: ScreenStore.idCounter++, active: true, name: "Login", url: "login" });
    ScreenStore.models.push({ id: "efueuehfhfu", screenId: ScreenStore.idCounter++, active: true, name: "Main", url: "main" });
    ScreenStore.models.push({ id: "iqigfyuwgqf", screenId: ScreenStore.idCounter++, active: true, name: "Step", url: "step" });
    ScreenStore.models.push({ id: "whfhuwfuguf", screenId: ScreenStore.idCounter++, active: true, name: "Report", url: "report" });
  }
  public static findByObjectId(id: string): ScreenModel {
    let m = ScreenStore.models;
    for (let i = 0; i < m.length; i++) {
      if (id == m[i].id) return m[i];
    }
    return null;
  }
  public static findById(id: number): ScreenModel {
    let m = ScreenStore.models;
    for (let i = 0; i < m.length; i++) {
      if (id == m[i].screenId) return m[i];
    }
    return null;
  }
  public static getItems(): ScreenModel[] {
    return ScreenStore.models;
  }
}
